const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

function capitalizeFirstLetter(value: string): string {
  if (!value) {
    return value;
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
}

function getLocalCalendarDayIndex(timestamp: number): number {
  const date = new Date(timestamp);
  return (
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) /
    MILLISECONDS_IN_DAY
  );
}

export function isSameLocalCalendarDay(a: number, b: number): boolean {
  return getLocalCalendarDayIndex(a) === getLocalCalendarDayIndex(b);
}

export function isTodayMessageBatch(
  createdMs: number,
  nowMs = Date.now(),
): boolean {
  if (!createdMs || createdMs <= 0) {
    return false;
  }

  return (
    getLocalCalendarDayIndex(createdMs) === getLocalCalendarDayIndex(nowMs)
  );
}

export function formatMessageBatchDateLabel(
  createdMs: number,
  lang?: string,
  nowMs = Date.now(),
): string {
  if (!createdMs || createdMs <= 0) {
    return '';
  }

  const locale = lang ?? undefined;
  const dayDiff =
    getLocalCalendarDayIndex(createdMs) - getLocalCalendarDayIndex(nowMs);

  if (dayDiff === 0 || dayDiff === -1) {
    const relativeDayLabel = new Intl.RelativeTimeFormat(locale, {
      numeric: 'auto',
    }).format(dayDiff, 'day');

    return capitalizeFirstLetter(relativeDayLabel);
  }

  const createdDate = new Date(createdMs);

  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(createdDate);
}
